import { Validators } from '@angular/forms';
import { BaseControl, Dropdown, TextArea, Textbox, Actividad, Option, Const } from '@app/shared';
import { isEmpty, find, result } from 'lodash';

export interface ConfigFields extends Actividad {
  statusOptions: Option[];
}

export class FormService {
  constructor() {}

  getFields(obj: Partial<ConfigFields>): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'nombre',
        type: 'text',
        label: 'Nombre:',
        placeholder: 'Nombre predeterminado de la actividad',
        value: !isEmpty(obj.nombre) ? obj.nombre : null,
        order: 1,
        validations: {
          validators: [Validators.required, Validators.maxLength(255)]
        }
      }),

      new TextArea({
        key: 'descripcion',
        label: 'Descripción:',
        placeholder: 'Descripción predeterminada de la actividad',
        rows: '2',
        value: !isEmpty(obj.descripcion) ? obj.descripcion : null,
        order: 2,
        validations: {
          validators: [Validators.required, Validators.minLength(5)]
        }
      }),

      new Dropdown({
        key: 'actividad_estado',
        label: 'Estado:',
        placeholder: 'Estado predeterminado de la actividad',
        value: !isEmpty(obj.actividad_estado)
                ? obj.actividad_estado.id
               : result (find(obj.statusOptions, {
                   value: Const.STATUS_ACTIVITY.inactive as any
                 }) , 'key') ,
        options: this.getFormatStatusOptions(obj.statusOptions),
        order: 3,
        validations: {
          validators: [Validators.required]
        }
      })
    ];
    return controls;
  }

  /**
   * Formatea los datos de las opciones para mostrar en el select del formulario
   *
   * @param {Option[]} getStatus
   * @returns {Option[]}
   * @memberof FormService
   */
  getFormatStatusOptions(getStatus: Option[]): Option[] {
    const formatStatus: Option[] = [];
    getStatus.forEach(item => {
      formatStatus.push(item);
    });
    formatStatus.forEach(item => {
      item.value = item.value.charAt(0).toUpperCase() +
                   item.value.replace('_', ' ').slice(1);
    });
    return formatStatus;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/activity/shared/form-service.ts